import { Component, ErrorInfo, PropsWithChildren, ReactNode } from 'react';

type Props = PropsWithChildren<{
	errorPage: ReactNode;
}>;

type State = {
	error?: unknown;
};

export class ErrorBoundary extends Component<Props, State> {
	constructor(props: Props) {
		super(props);
		this.state = { error: false };
	}

	static getDerivedStateFromError(error: unknown): State {
		return { error };
	}

	componentDidCatch(error: Error, errorInfo: ErrorInfo) {
		console.error(error);
	}

	render() {
		if (this.state.error) {
			return this.props.errorPage;
		}
		return this.props.children;
	}
}
